import React, { useState } from "react";
import APIUsageTable from "./components/APIUsageTable";
import APIUsageDetail from "./components/APIUsageDetail";
import APIUsageOverview from "./components/overview/APIUsageOverview";

const APIUsageLogs = () => {
    const [view, setView] = useState("list"); // "list" or "detail"
    const [selectedUser, setSelectedUser] = useState(null);

    const handleViewDetail = (user) => {
        setSelectedUser(user);
        setView("detail");
    };

    const handleBack = () => {
        setView("list");
        setSelectedUser(null);
    };

    return (
        <div className="min-h-screen p-3 sm:p-4 md:p-6 space-y-6">
            {view === "list" ? (
                <>
                    <APIUsageOverview />
                    <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-sm border border-gray-100">
                        <APIUsageTable onViewDetail={handleViewDetail} />
                    </div>
                </>
            ) : (
                <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-sm border border-gray-100">
                    <APIUsageDetail onBack={handleBack} userData={selectedUser} />
                </div>
            )}
        </div>
    );
};

export default APIUsageLogs;
